import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";
import { X, Filter } from "lucide-react";
import FabricSeriesHeader from "../components/FabricSeriesHeader";
import ImageZoomWithButton from "../components/button/ImageZoomWithButton";
import { filterFabricsByGroup, groupFabric } from "../actions/blindActions";
import { addToSwatchCart, removeFromSwatchCart } from "../actions/cartActions";
import { useMediaQuery } from "react-responsive";
import { LoadingSpinner } from "../components/LoadingSpinner";

const FabricSwatch = () => {
	// States
	const [loading, setLoading] = useState(true);
	const [selectedShade, setSelectedShade] = useState("roller");
	const [selectedColor, setSelectedColor] = useState("");
	const [selectedGroup, setSelectedGroup] = useState("All");
	const [selectedPenetration, setSelectedPenetration] = useState("All");
	const [filteredFabrics, setFilteredFabrics] = useState([]);
	const [allGroups, setAllGroups] = useState([]);
	const [allColours, setAllColours] = useState([]);
	const [showFilters, setShowFilters] = useState(false);
	const [toast, setToast] = useState(null);
	const isMobile = useMediaQuery({ maxWidth: 768 });

	const dispatch = useDispatch();
	const fabricCart = useSelector((state) => state.swatchCart.swatchCartItems);

	const loadFabrics = (shade) => {
		filterFabricsByGroup(
			24,
			shade + " shade",
			selectedGroup,
			"All",
			selectedColor
		).then((res) => {
			groupFabric(24, shade + " shade")
				.then((fabrics) => {
					let tempGroups = [];

					fabrics.forEach((fabric) => {
						if (fabric !== "Sustainable" && fabric !== "NULL") {
							tempGroups.push(fabric);
						}
					});
					for (let i = 0; i < res.seriesColourImage.length; i++) {
						// If series tarts with Cs, make it CS

						for (let j = 0; j < res.seriesColourImage[i].image.length; j++) {
							res.seriesColourImage[i].image[j] = res.seriesColourImage[
								i
							].image[j].replace("image/", "images/");
							// Check if jpg does not exist in the image name
							if (res.seriesColourImage[i].image[j].indexOf(".jpg") === -1)
								res.seriesColourImage[i].image[j] +=
									res.seriesColourImage[i].colour[j] + ".jpg";
						}
					}

					res.uniqueColourFamily.sort();
					setAllGroups(tempGroups);
					setAllColours(res.uniqueColourFamily);

					if (selectedColor !== "") {
						let temp = [];
						res.seriesColourImage.forEach((item) => {
							let code = [];
							let colours = [];
							let colourFamily = [];
							let groups = [];
							let image = [];
							let series = [];
							let penetration = [];
							let composition = [];
							let fire_rating = [];
							let green_rating = [];
							let antimicrobial_rating = [];
							let ocs_name = [];
							let ocs_colour_name = [];

							item.colourFamily.forEach((colour, i) => {
								if (colour.toLowerCase() === selectedColor.toLowerCase()) {
									code.push(item.code?.[i]);
									colours.push(item.colour?.[i]);
									colourFamily.push(item.colourFamily?.[i]);
									groups.push(item.group?.[i]);
									image.push(item.image?.[i]);
									series.push(item.series?.[i]);
									penetration.push(item.light_penetration?.[i]);
									composition.push(item.composition?.[i]);
									fire_rating.push(item.fire_rating?.[i]);
									green_rating.push(item.green_rating?.[i]);
									antimicrobial_rating.push(item.antimicrobial_rating?.[i]);
									ocs_name.push(item.ocs_name?.[i]);
									ocs_colour_name.push(item.ocs_colour_name?.[i]);
								}
							});
							// console.log(temp)
							if (
								code.length !== 0 &&
								colours.length !== 0 &&
								colourFamily.length !== 0 &&
								groups.length !== 0 &&
								image.length !== 0 &&
								series.length !== 0 &&
								ocs_name.length !== 0 &&
								ocs_colour_name.length !== 0
							) {
								temp.push({
									code: code,
									colour: colours,
									colourFamily: colourFamily,
									group: groups,
									image: image,
									series: series,
									priceGroup: item?.priceGroup,
									penetration: item.light_penetration,
									composition: item.composition,
									fire_rating: item.fire_rating,
									green_rating: item.green_rating,
									antimicrobial_rating: item.antimicrobial_rating,
									ocs_name: ocs_name,
									ocs_colour_name: ocs_colour_name,
								});
							}
						});
						res.seriesColourImage = temp;
					}

					// Convert to a single index
					let temp = [];
					res.seriesColourImage.forEach((item) => {
						item.image.forEach((image, i) => {
							// If selectedPenetration is not "All" then select only those fabrics which have the selected penetration
							if (selectedPenetration !== "All") {
								if (String(item?.light_penetration[i]) === "0.01")
									item.light_penetration[i] = "1%";
								if (String(item?.light_penetration[i]) === "0.03")
									item.light_penetration[i] = "3%";
								if (String(item?.light_penetration[i]) === "0.05")
									item.light_penetration[i] = "5%";
								if (String(item?.light_penetration[i]) === "0.08")
									item.light_penetration[i] = "8%";
								if (
									String(item?.light_penetration[i]) === selectedPenetration
								) {
									temp.push({
										code: item.code?.[i],
										colour: item.colour?.[i],
										colourFamily: item.colourFamily?.[i],
										group: item.group?.[i],
										image: image,
										series: item.series?.[i],
										priceGroup: item?.priceGroup,
										penetration: item?.light_penetration?.[i],
										ocs_name: item?.ocs_name?.[i],
										ocs_colour_name: item.ocs_colour_name?.[i],
										composition: item.composition?.[i],
										fire_rating: item.fire_rating?.[i],
										green_rating: item.green_rating?.[i],
										antimicrobial_rating: item.antimicrobial_rating?.[i],
									});
								}
							} else {
								temp.push({
									code: item.code?.[i],
									colour: item.colour?.[i],
									colourFamily: item.colourFamily?.[i],
									group: item.group?.[i],
									image: image,
									series: item.series?.[i],
									priceGroup: item?.priceGroup,
									penetration: item.light_penetration,
									composition: item.composition?.[i],
									fire_rating: item.fire_rating?.[i],
									green_rating: item.green_rating?.[i],
									antimicrobial_rating: item.antimicrobial_rating?.[i],
									ocs_name: item?.ocs_name?.[i],
									ocs_colour_name: item.ocs_colour_name?.[i],
								});
							}
						});
					});
					res.seriesColourImage = temp;

					res.seriesColourImage.sort((a, b) => {
						return a.series.localeCompare(b.series);
					});
					console.log(res.seriesColourImage);
					setFilteredFabrics(res.seriesColourImage);
					setLoading(false);
				})
				.catch((err) => {
					console.log(err);
				});
		});
	};

	// Load fabrics on mount and filter changes
	useEffect(() => {
		loadFabrics(selectedShade);
	}, [selectedShade, selectedColor, selectedGroup, selectedPenetration]);

	const handleAddToCart = (item) => {
		if (fabricCart.length >= 5) {
			setToast({
				message: "Maximum 5 samples allowed",
				type: "error",
			});
			return;
		}

		const fabricItem = {
			shade: `${selectedShade.charAt(0).toUpperCase()}${selectedShade.slice(
				1
			)} Shade`,
			name: `${item.series} ${item.colour}`,
			image: item.image,
			code: item.code,
			type: item.series,
			series: item.colour,
			ocs_name: item.ocs_name,
			ocs_colour_name: item.ocs_colour_name,
		};

		dispatch(addToSwatchCart({ item: fabricItem }));
		setToast({ message: "Sample added", type: "success" });
	};

	// Remove fabric from cart
	const handleRemoveFromCart = (item) => {
		dispatch(removeFromSwatchCart(item));
		setToast({ message: "Sample removed", type: "success" });
	};

	const existsInCart = (code) => {
		return fabricCart.some(
			(item) =>
				item.item.code === code &&
				item.item.shade ===
					`${selectedShade.charAt(0).toUpperCase()}${selectedShade.slice(
						1
					)} Shade`
		);
	};

	const FilterSection = () => (
		<div className="space-y-6">
			{/* Shade Type Selection */}
			<div>
				<h3 className="font-medium mb-3">Shade Type</h3>
				<div className="grid grid-cols-3 gap-4">
					{[
						{ type: "roller", label: "Roller Shade" },
						{ type: "banded", label: "Zebra Shade" },
						{ type: "sheer", label: "Sheer Shade" },
					].map(({ type, label }) => (
						<motion.button
							key={type}
							onClick={() => {
								setSelectedShade(type);
								setSelectedColor("");
								setSelectedGroup("All");
							}}
							whileHover={{ scale: 1.02 }}
							whileTap={{ scale: 0.98 }}
							className={`
					p-3 border-2 rounded-xl transition-all bg-white
					${
						selectedShade === type
							? "border-primary shadow-lg shadow-primary/10"
							: "border-gray-200 hover:border-primary/30"
					}
				  `}
						>
							<div className="aspect-[4/3] rounded-xl overflow-hidden mb-2">
								<img
									src={`/images/fabricSwatch/${type}_shade_swatches_v1.png`}
									alt={label}
									className="w-full h-full object-contain"
								/>
							</div>
							<p className="text-sm font-medium text-center">{label}</p>
						</motion.button>
					))}
				</div>
			</div>

			{/* Transparency Selection */}
			<div>
				<h3 className="font-medium mb-3">Fabric Transparency</h3>
				<div className="flex flex-wrap gap-2">
					{["All", ...allGroups].map((group) => (
						<motion.button
							key={group}
							whileHover={{ scale: 1.05 }}
							whileTap={{ scale: 0.95 }}
							onClick={() => setSelectedGroup(group)}
							className={`
					px-4 py-2 rounded-xl text-sm font-medium transition-colors
					${
						selectedGroup === group
							? "bg-primary text-white"
							: "bg-white border border-gray-200 hover:bg-gray-50"
					}
				  `}
						>
							{group}
						</motion.button>
					))}
				</div>
			</div>
			{/* Color Selection */}
			<div>
				<h3 className="font-medium mb-3">Fabric Color</h3>
				<div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 gap-3">
					<motion.button
						whileHover={{ scale: 1.05 }}
						whileTap={{ scale: 0.95 }}
						onClick={() => setSelectedColor("")}
						className={`
				  p-2 border-2 rounded-xl transition-all aspect-square bg-white
				  ${
						selectedColor === ""
							? "border-primary shadow-sm shadow-primary/10"
							: "border-gray-200 hover:border-primary/30"
					}
				`}
					>
						<div className="w-full h-3/4 bg-gradient-to-r from-gray-100 to-gray-300 rounded mb-2"></div>
						<span className="text-xs font-medium block truncate">
							All Colors
						</span>
					</motion.button>
					{allColours.map((color) => (
						<motion.button
							key={color}
							whileHover={{ scale: 1.05 }}
							whileTap={{ scale: 0.95 }}
							onClick={() => setSelectedColor(color)}
							className={`
					p-2 border-2 rounded-xl transition-all aspect-square bg-white
					${
						selectedColor === color
							? "border-primary shadow-sm shadow-primary/10"
							: "border-gray-200 hover:border-primary/30"
					}
				  `}
						>
							<div className="w-full h-3/4 rounded mb-2 overflow-hidden">
								<img
									src={`/images/fabricSwatch/${color.toLowerCase()}.jpg`}
									alt={color}
									className="w-full h-full object-cover"
								/>
							</div>
							<span className="text-xs font-medium block truncate">
								{color}
							</span>
						</motion.button>
					))}
				</div>
			</div>

			{/* New penetration filter */}
			{selectedGroup === "Sunscreen" && (
				<div>
					<h3 className="font-medium mb-3">Select Light Penetration</h3>
					<div className="flex flex-wrap gap-2">
						{["All", "1%", "3%", "5%"].map((penetration) => (
							<motion.button
								key={penetration}
								whileHover={{ scale: 1.05 }}
								whileTap={{ scale: 0.95 }}
								onClick={() => setSelectedPenetration(penetration)}
								className={`
              px-4 py-2 rounded-xl text-sm font-medium transition-colors
              ${
								selectedPenetration === penetration
									? "bg-primary text-white"
									: "bg-white border border-gray-200 hover:bg-gray-50"
							}
            `}
							>
								{penetration}
							</motion.button>
						))}
					</div>
				</div>
			)}
		</div>
	);

	// Cart preview component
	const CartPreview = () => (
		<div className="fixed bottom-2 left-4 right-4 md:left-auto md:w-96 bg-white rounded-xl shadow-lg border border-gray-200 z-50">
			<div className="p-3 border-b border-gray-200 flex items-center justify-between">
				<span className="font-medium">
					Selected Samples ({fabricCart.length}/5)
				</span>
				<button
					onClick={() => (window.location.href = "/swatchcheckout")}
					disabled={fabricCart.length === 0}
					className="px-4 py-1.5 rounded-xl text-sm font-medium bg-primary text-white disabled:opacity-50"
				>
					Checkout
				</button>
			</div>
			<div className="max-h-48 overflow-y-auto p-2">
				<div className="grid grid-cols-3 gap-2">
					{fabricCart.map((item, index) => (
						<div key={index} className="relative group">
							<img
								src={item.item.image.toLowerCase()}
								alt={item.item.ocs_colour_name}
								className="w-full aspect-square object-cover rounded-xl"
							/>
							<button
								onClick={() => handleRemoveFromCart(item)}
								className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-white shadow flex items-center justify-center border border-gray-200"
							>
								<X size={12} />
							</button>
							<p className="mt-1 text-xs text-center truncate">
								{item.item.ocs_colour_name}
							</p>
						</div>
					))}
				</div>
			</div>
		</div>
	);

	return (
		<div className="min-h-screen bg-gray-50">
			{/* Header */}
			<section className="relative pt-12 overflow-hidden">
				<div className="container mx-auto px-4">
					<motion.div
						initial={{ opacity: 0, y: 30 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ type: "spring", stiffness: 400, damping: 30 }}
						className="text-center relative z-10"
					>
						{/* <motion.span
							className="inline-block px-4 py-2 rounded-full bg-primary/10 text-primary text-sm mb-6 font-medium"
							initial={{ scale: 0 }}
							animate={{ scale: 1 }}
							transition={{
								type: "spring",
								stiffness: 400,
								damping: 30,
								delay: 0.2,
							}}
						>
							5 Free Samples
						</motion.span> */}

						<h1 className="text-5xl md:text-7xl font-bold mb-6">
							Free Fabric
							<span className="relative ml-4">
								<span className="text-primary">Samples</span>
							</span>
						</h1>
						<motion.p
							className="text-xl text-gray-600"
							initial={{ opacity: 0, y: 20 }}
							animate={{ opacity: 1, y: 0 }}
						>
							Request up to 5 Free Samples and feel the premium quality of our
							materials before making your decision.
						</motion.p>
						<h2 className="text-xl mb-12"></h2>
					</motion.div>

					{/* Decorative elements */}
					<div className="absolute inset-0 -z-10">
						<div className="absolute top-20 left-20 w-72 h-72 bg-primary/5 rounded-full blur-3xl" />
						<div className="absolute bottom-20 right-20 w-72 h-72 bg-secondary/5 rounded-full blur-3xl" />
					</div>
				</div>
			</section>

			{/* Main Content */}
			<div className="bg-white rounded-xl border border-gray-200 p-4 max-w-6xl mx-auto">
				{/* Filter Toggle (Mobile) */}
				<div className="md:hidden mb-4">
					<button
						onClick={() => setShowFilters(!showFilters)}
						className="w-full px-4 py-2 bg-white rounded-xl border border-gray-200 flex items-center justify-between"
					>
						<span className="font-medium">Filters</span>
						<Filter size={20} />
					</button>
				</div>

				{/* Filters */}
				<AnimatePresence>
					{(showFilters || !isMobile) && (
						<motion.div
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
							className="p-4 mb-6"
						>
							<h2 className="mb-4 hidden md:block text-2xl font-bold">
								Filters
							</h2>

							<FilterSection />
						</motion.div>
					)}
				</AnimatePresence>

				{/* Fabric Grid */}
				{loading ? (
					<LoadingSpinner text="Loading Fabrics" />
				) : filteredFabrics.length === 0 ? (
					<div className="text-center py-12 text-gray-500">
						No fabrics found with selected filters
					</div>
				) : (
					<div className="space-y-6">
						{Object.entries(
							filteredFabrics.reduce(
								(acc, item) => ({
									...acc,
									[item.ocs_name]: [...(acc[item.ocs_name] || []), item],
								}),
								{}
							)
						).map(([series, items]) => (
							<div key={series} className="overflow-hidden">
								<div className="p-4 border-b border-gray-200">
									<FabricSeriesHeader
										title={series}
										headerInfo={{
											...items[0],
											width: items[0].code.split("-").pop(),
											group:
												items[0].group.charAt(0).toUpperCase() +
												items[0].group.slice(1),
										}}
									/>
								</div>
								<div className="p-4">
									<div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
										{items.map((item, idx) => {
											const inCart = existsInCart(item.code);
											return (
												<div key={idx} className="group">
													<div className="relative">
														<ImageZoomWithButton
															item={item}
															isFabricSelected={false}
															customize={false}
														/>
														<button
															onClick={() =>
																inCart
																	? handleRemoveFromCart({
																			item: {
																				shade:
																					selectedShade
																						.charAt(0)
																						.toUpperCase() +
																					selectedShade.slice(1) +
																					" Shade",
																				name: item.series + " " + item.colour,
																				image: item.image,
																				code: item.code,
																				type: item.series,
																				series: item.colour,
																				ocs_name: item.ocs_name,
																				ocs_colour_name: item.ocs_colour_name,
																			},
																	  })
																	: handleAddToCart(item)
															}
															className={`
									w-full py-1.5 text-sm font-medium mt-2 rounded-xl transition-colors
									${
										inCart
											? "bg-primary/50 text-white hover:bg-primary"
											: "bg-primary/10 text-primary hover:bg-primary/20"
									}
								  `}
														>
															{inCart ? "Remove" : "Add Sample"}
														</button>
													</div>
													<p className="mt-2 text-sm text-center">
														{item.ocs_colour_name}
													</p>
												</div>
											);
										})}
									</div>
								</div>
							</div>
						))}
					</div>
				)}
			</div>

			{/* Cart Preview */}
			{fabricCart.length > 0 && <CartPreview />}

			{/* Toast */}
			<AnimatePresence>
				{toast && (
					<motion.div
						initial={{ opacity: 0, y: 20 }}
						animate={{ opacity: 1, y: 0 }}
						exit={{ opacity: 0, y: 20 }}
						className={`
				  fixed bottom-20 right-4 px-4 py-2 rounded-xl shadow-lg
				  ${
						toast.type === "error"
							? "bg-red-50 text-red-600"
							: "bg-green-50 text-green-600"
					}
				`}
						onAnimationComplete={() => setTimeout(() => setToast(null), 2000)}
					>
						{toast.message}
					</motion.div>
				)}
			</AnimatePresence>
		</div>
	);
};

export default FabricSwatch;
